module.exports = __webpack_public_path__ + "img/32.5bb8d11e.png";